import { Component } from '@angular/core';

@Component({
    selector: 'sbpro-lorem-ipsum',
    templateUrl: './lorem-ipsum.component.html',
    styleUrls: ['lorem-ipsum.component.scss'],
})
export class LoremIpsumComponent {
    constructor() {}
}
